import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Chart from "react-apexcharts";
import "bootstrap/dist/css/bootstrap.min.css";

function Dashboard() {
  const navigate = useNavigate();
  const [orderType, setOrderType] = useState("take-away"); 
  const [selectedTables, setSelectedTables] = useState(() => {
    // Load from sessionStorage on first render
    const saved = sessionStorage.getItem("selectedTables");
    return saved ? JSON.parse(saved) : [];
  });
    useEffect(() => {
    const savedType = sessionStorage.getItem("orderType");
    if (savedType) {
      setOrderType(savedType);
    }
  }, []);

  // Handle selection
  const handleSelect = (type) => {
    setOrderType(type);
    sessionStorage.setItem("orderType", type);

    if (type === "dine-in") {
      navigate("/table");
    } else if (type === "take-away") {
      navigate("/item");
    }
  };
  const chartOptions = {
    chart: {
      type: "line",
      sparkline: { enabled: true },
      toolbar: { show: false },
    },
    stroke: { curve: "smooth", width: 2 },
    colors: ["#0d6efd"], // bootstrap primary color
    tooltip: { enabled: false },
  };

  return (
    <main className="main-wrapper">
      <div className="main-content">

        <div className="row">
          {/* Total Sales */}
          
          <div className="col-lg-3">
            <div className="card border-primary border-bottom rounded-4">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <p className="mb-0 fs-6">Total Sales</p>
                </div>
                <div className="d-flex align-items-center justify-content-between mt-3">
                  <div>
                    <h4 className="mb-0 fw-bold">$8925.60</h4>
                    <div className="d-flex align-items-center justify-content-start gap-1 text-success mt-4">
                      <span className="material-icons-outlined fs-6">north</span>
                      <p className="mb-0 fs-6">5.6%</p>
                    </div>
                  </div>
                  <Chart
                    options={chartOptions}
                    series={[{ data: [10, 25, 20, 35, 40, 30, 50] }]}
                    type="area"
                    width="200"
                    height="100"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Total Income */}
          <div className="col-lg-3">
            <div className="card border-success border-bottom rounded-4">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <p className="mb-0 fs-6">Total Income</p>
                </div>
                <div className="d-flex align-items-center justify-content-between mt-3">
                  <div>
                    <h4 className="mb-0 fw-bold">$9627.20</h4>
                    <div className="d-flex align-items-center justify-content-start gap-1 text-success mt-4">
                      <span className="material-icons-outlined fs-6">north</span>
                      <p className="mb-0 fs-6">5.6%</p>
                    </div>
                  </div>
                  <Chart
                    options={{ ...chartOptions, colors: ["#198754"] }} // green
                    series={[{ data: [15, 20, 30, 25, 45, 55, 65] }]}
                    type="area"
                     width="200"
                    height="100"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Product Views */}
          <div className="col-lg-3">
            <div className="card border-danger border-bottom rounded-4">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <p className="mb-0 fs-6">Product Views</p>
                </div>
                <div className="d-flex align-items-center justify-content-between mt-3">
                  <div>
                    <h4 className="mb-0 fw-bold">65.7K</h4>
                    <div className="d-flex align-items-center justify-content-start gap-1 text-success mt-4">
                      <span className="material-icons-outlined fs-6">north</span>
                      <p className="mb-0 fs-6">5.6%</p>
                    </div>
                  </div>
                  <Chart
                    options={{ ...chartOptions, colors: ["#dc3545"] }} // red
                    series={[{ data: [5, 15, 10, 20, 25, 15, 30] }]}
                    type="area"
                     width="200"
                    height="100"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* New Accounts */}
          <div className="col-lg-3">
            <div className="card border-warning border-bottom rounded-4">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <p className="mb-0 fs-6">New Accounts</p>
                </div>
                <div className="d-flex align-items-center justify-content-between mt-3">
                  <div>
                    <h4 className="mb-0 fw-bold">2497</h4>
                    <div className="d-flex align-items-center justify-content-start gap-1 text-success mt-4">
                      <span className="material-icons-outlined fs-6">north</span>
                      <p className="mb-0 fs-6">5.6%</p>
                    </div>
                  </div>
                  <Chart
                    options={{ ...chartOptions, colors: ["#ffc107"] }} // yellow
                    series={[{ data: [8, 12, 18, 15, 22, 28, 35] }]}
                    type="area"
                     width="200"
                    height="100"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* end row */}
       
      </div>
    </main>
  );
}

export default Dashboard;
